/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoOffIcon20Solid = forwardRef('TechCamVideoOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.945 1.204a1.125 1.125 0 0 0-1.59 1.592l1.822 1.822A2.995 2.995 0 0 0 1 7v6a3 3 0 0 0 3 3h8c.456 0 .888-.102 1.275-.284l3.08 3.08a1.125 1.125 0 0 0 1.59-1.591l-16-16Z" }),
        React.createElement("path", { d: "M20 13.983c0 .843-.786 1.389-1.523 1.223L7.271 4H12a3 3 0 0 1 3 3v.292l2.995-2.271c.823-.625 2.005-.037 2.005.996v7.966Z" })));
});
